<template>
  <section class="mb-3">
    <h5>Dados da Obra</h5>
    <d-tabs class="w-100 mb-2" ref="tabs">
      <d-tab :title="project.label" class="p-3" v-for="(project, index) in model" :key="index">
        <d-form-row>

          <!-- Nome -->
          <d-col md="8" class="form-group">
            <label for="label">Identificação da obra</label>
            <d-form-input
              :state="hasError(project, 'label')"
              type="text"
              id="label"
              placeholder="Nome"
              v-model="project.label"
            />
            <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
          </d-col>

        </d-form-row>

        <d-form-row>

          <!-- CEP -->
          <d-col md="2"  class="form-group">
            <label for="inputCEP">CEP</label>
            <masked-input
              type="text"
              class="text-left form-control"
              id="inputCEP"
              placeholder="00.000-000"
              :mask="[/\d/, /\d/,'.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
              :guide="false"
              v-model="project.address.zipcode"
              :class="['is-' + hasErrorInAddress(project, 'zipcode')]"
              @blur="consultaCEP(project)"
            ></masked-input>
            <d-form-invalid-feedback>CEP é obrigatório</d-form-invalid-feedback>
          </d-col>

          <!-- Logradouro -->
          <d-col md="8" class="form-group">
            <label for="feInputEndereco">Logradouro</label>
            <d-form-input
              type="text"
              id="feInputEndereco"
              placeholder="Rua,Av,Travessa"
              v-model="project.address.street"
              @change="capitalizeAddressInput('street', index)"
              :state="hasErrorInAddress(project, 'street')"
            />
            <d-form-invalid-feedback>Logradouro é obrigatório</d-form-invalid-feedback>
          </d-col>

          <!-- Numero -->
          <d-col md="2" class="form-group">
            <label for="feInputNumero">Número</label>
            <d-form-input
              type="text"
              id="feInputNumero"
              placeholder="Número"
              v-model="project.address.number"
              :state="hasErrorInAddress(project, 'number')"
            />
            <d-form-invalid-feedback>Número é obrigatório</d-form-invalid-feedback>
          </d-col>

        </d-form-row>

        <d-form-row>

          <!-- Complemento -->
          <d-col md="3" class="form-group">
            <label for="feInputComplemento">Complemento</label>
            <d-form-input
              type="text"
              id="feInputComplemento"
              v-model="project.address.address2"
              placeholder="apartamento,bloco,etc..."
              @change="capitalizeAddressInput('address2', index)"
            />
          </d-col>

          <!-- Bairro -->
          <d-col md="3" class="form-group">
            <label for="feInputBairro">Bairro</label>
            <d-form-input
              type="text"
              id="feInputBairro"
              v-model="project.address.district"
              @change="capitalizeAddressInput('district', index)"
              :state="hasErrorInAddress(project, 'district')"
            />
            <d-form-invalid-feedback>Bairro é obrigatório</d-form-invalid-feedback>
          </d-col>

          <!-- Cidade -->
          <d-col md="4" class="form-group">
            <label for="feInputCidade">Cidade</label>
            <d-form-input
              type="text"
              id="feInputCidade"
              v-model="project.address.city"
              @change="capitalizeAddressInput('city', index)"
              :state="hasErrorInAddress(project, 'city')"
            />
            <d-form-invalid-feedback>Cidade é obrigatório</d-form-invalid-feedback>
          </d-col>

          <!-- Estado -->
          <d-col md="2" class="form-group">
            <label for="feInputEstado">Estado</label>
            <select-state :model.sync="project.address.state" :validate="hasErrorInAddress(project, 'state')" />
            <d-form-invalid-feedback>Estado é obrigatório</d-form-invalid-feedback>
          </d-col>

        </d-form-row>

      </d-tab>
    </d-tabs>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { capitalize } from '_utils/string';
import ValidateForm from '_common/mixins/ValidateForm';
import InputPhone from '_shared/InputPhone.vue';
import MaskedInput from 'vue-text-mask';
import SelectState from '_shared/SelectState.vue';
import ProjectService from '_services/rest/modules/project';
import { _LOAD_MODEL_ } from './CustomerModel';

export default {
  name: 'project-form',
  mixins: [ValidateForm],
  components: {
    InputPhone,
    MaskedInput,
    SelectState,
  },
  props: {
    projects: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      errors: {
        city: { required: false },
        label: { required: false },
        state: { required: false },
        street: { required: false },
        number: { required: false },
        zipcode: { required: false },
        district: { required: false },
      },
    };
  },
  computed: {
    model: {
      get() {
        return this.projects;
      },
      set(val) {
        return this.$emit('update:projects', val);
      },
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    consultaCEP(project) {
      if (project.address.zipcode) {
        ProjectService.getCep(project.address.zipcode)
          .then(response => {
            project.address.city = response.localidade;
            project.address.state = response.uf;
            project.address.street = response.logradouro;
            project.address.district = response.bairro;
          });
      }
    },
    capitalizeAddressInput(field, index) {
      this.model[index].address[field] = capitalize(this.model[index].address[field]);
    },
    setObjectErrors() {
      this.model.forEach(project => {
        project.errors = this.errors;
        return project;
      });
    },
    checkProjectForm() {
      this.$forceUpdate();
      const fields = ['city', 'state', 'street', 'number', 'zipcode', 'district'];
      this.submited = true;
      let valid = true;
      this.model.forEach(project => {
        project.errors.label.required = !project.label;
        fields.forEach(field => {
          if (project.errors[field]) {
            project.errors[field].required = (!project.address[field]);
            if (project.errors[field].required) {
              valid = false;
            }
          }
        });
      });
      return valid;
    },
    hasError(project, field) {
      if (project.errors && this.submited) {
        if (project.errors[field].required) {
          return 'invalid';
        }
        return 'valid';
      }
      return null;
    },
    hasErrorInAddress(project, field) {
      if (project.errors && this.submited) {
        if (project.errors[field].required) {
          return 'invalid';
        }
        return 'valid';
      }
      return null;
    },
  },
  mounted() {
    this.setObjectErrors();
    Events.$on(_LOAD_MODEL_, () => {
      this.setObjectErrors();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}
</style>
